export var UserExamStatus;
(function (UserExamStatus) {
    UserExamStatus["APPLIED"] = "Applied";
    UserExamStatus["EXCELLENT"] = "Excellent";
    UserExamStatus["OUTSTANDING"] = "Outstanding";
    UserExamStatus["ELIGIBLE"] = "Eligible";
    UserExamStatus["NOT_ELIGIBLE"] = "Not Eligible";
    UserExamStatus["ELIGIBLE_TRACK_2"] = "Eligible Track 2";
    UserExamStatus["ELIGIBLE_TRACK_1"] = "Eligible Track 1";
    UserExamStatus["ELIGIBLE_FOR_Hackathon"] = "Eligible For Hackathon";
    UserExamStatus["FAIR"] = "Fair";
    UserExamStatus["GOOD"] = "Good";
    UserExamStatus["NEEDS_IMPROVEMENT"] = "Needs Improvement";
    UserExamStatus["RESULT_CALCULATING"] = "Result Calculating";
    UserExamStatus["INTERVIEW_CLEARED"] = "Completed";
    UserExamStatus["INTERVIEW_NO_SHOW"] = "No Show";
    UserExamStatus["ALL"] = "All";
    UserExamStatus["SELECTED"] = "SELECTED";
    UserExamStatus["DOCUMENTS_APPROVED"] = "DOCUMENTS_APPROVED";
    UserExamStatus["LOI_SENT"] = "LOI_SENT";
    UserExamStatus["LOI_ACCEPTED"] = "LOI_ACCEPTED";
    UserExamStatus["REJECTED"] = "REJECTED";
})(UserExamStatus || (UserExamStatus = {}));
export var UserResultSubmitReason;
(function (UserResultSubmitReason) {
    UserResultSubmitReason["CHEATING"] = "CHEATING";
    UserResultSubmitReason["TIMEOUT"] = "TIMEOUT";
    UserResultSubmitReason["NORMAL"] = "NORMAL";
    UserResultSubmitReason["EXIT_COUNTER_MAX_VALUE"] = "EXIT_COUNTER_MAX_VALUE";
    UserResultSubmitReason["PROCTORING_TEST_FAILED"] = "PROCTORING_TEST_FAILED";
    UserResultSubmitReason["TIMER_COUNTDOWN_EXPIRED_AUTOMATICALLY"] = "TIMER_COUNTDOWN_EXPIRED_AUTOMATICALLY";
    UserResultSubmitReason["MALPRACTICE_COUNTER_EXCEEDED"] = "MALPRACTICE_COUNTER_EXCEEDED";
    UserResultSubmitReason["LIVE_PROCTORING_VIOLATION"] = "LIVE_PROCTORING_VIOLATION";
})(UserResultSubmitReason || (UserResultSubmitReason = {}));
export var UserCodingSetStatus;
(function (UserCodingSetStatus) {
    UserCodingSetStatus["PASS"] = "Passed";
    UserCodingSetStatus["PARTIALLY_PASS"] = "Partially Passed";
    UserCodingSetStatus["FAIL"] = "Failed";
})(UserCodingSetStatus || (UserCodingSetStatus = {}));
